import { render, staticRenderFns } from "./EnviosComponent.vue?vue&type=template&id=05df5478&scoped=true"
import script from "./EnviosComponent.vue?vue&type=script&lang=js"
export * from "./EnviosComponent.vue?vue&type=script&lang=js"
import style0 from "./EnviosComponent.vue?vue&type=style&index=0&id=05df5478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df5478",
  null
  
)

export default component.exports